import { MuiOtpInput } from 'mui-one-time-password-input';
import React, { useState } from 'react';
import { Button, Modal, ModalProps } from 'react-bootstrap';
import CountDownLink from './CountDownLink';
import Messages from './Messages';

export type OTPModalProps = ModalProps & {
  onClickVerifyOTP: (otp?: string) => Promise<string | undefined>;
  onReRequestOTP: () => void;
};

const OTPModal = ({ onHide, onReRequestOTP, onClickVerifyOTP, ...props }: OTPModalProps) => {
  const [otp, setOtp] = React.useState<string>();
  const [errorMessage, setErrorMessage] = useState<string | undefined>();

  return (
    <Modal backdrop="static" centered onHide={onHide} {...props}>
      <Modal.Body className="otpmodal-body d-flex flex-column gap-3 align-items-center justify-content-center px-5 py-4">
        <h1 className="otpmodal-title ">認証</h1>
        <p>認証コードをメールで送信しました。</p>
        <MuiOtpInput length={6} value={otp} onChange={setOtp} className="otpmodal-input" />
        <div>
          <Messages valid_msg={errorMessage} />
        </div>
        <Button
          disabled={otp?.length !== 6}
          onClick={async () => {
            const resErrorMessage = await onClickVerifyOTP(otp);
            setErrorMessage(resErrorMessage);
          }}
          size="lg"
        >
          確認
        </Button>
        <p className="otpmodal-requestOtp">
          コードを受け取っていませんか？
          <CountDownLink countdownSeconds={60} onClick={onReRequestOTP}>
            再送信を依頼する
          </CountDownLink>
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default OTPModal;
